import "roboto-fontface/css/roboto/roboto-fontface.css";
import "material-design-icons-iconfont";
import "./index.css";
import {autorun, configure} from "mobx";
import {render} from "preact";
import {registerSW} from "virtual:pwa-register";

// Preserve mobx 4 semantics: previous code mutated observable state outside actions.
configure({enforceActions: "never"});
import {
	connection,
	cubeModel,
	installAutoOccupy,
	installDeviceResumeDetection,
	occupancyModel,
	updateModel,
} from "./model";
import {AppShell} from "./view/AppShell";

if (location.hostname !== "localhost") {
	const updateSW = registerSW({
		immediate: true,
		onNeedRefresh() {
			updateModel.pending = true;
			updateSW(true);
		},
		onOfflineReady() {
			console.log("SW: offline ready");
		},
		onRegisteredSW(_swUrl, registration) {
			if (registration) {
				setInterval(() => registration.update(), 24 * 60 * 60 * 1000);
			}
		},
		onRegisterError(error) {
			console.error("SW registration failed", error);
		},
	});
}

autorun(async () => {
	if (connection.online) {
		await cubeModel.fetch();
	}
});

autorun(async () => {
	if (connection.online) {
		await occupancyModel.fetch();
	}
});

installAutoOccupy();
installDeviceResumeDetection();

render(<AppShell />, document.body);

const appLoadingContainer = document.getElementById("app-loading-container");
if (appLoadingContainer) {
	appLoadingContainer.parentNode?.removeChild(appLoadingContainer);
}
